import React from "react";

const Bash_Head = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Head</h2>
      <p>Show the beginning of a file.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>head [options] [file]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>head -n 20 file.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Quick way to inspect file headers.</p>
    </div>
  );
};

export default Bash_Head;
